import React from 'react'
import { FormattedMessage } from 'react-intl'

import {
  BigLoaderComponent,
  VideoPlayerComponent,
  RibbonComponent,
  IconComponent,
} from '../../../../sharedLegacy/components'
import { StreamingInfoPanelComponent } from '../..'

const getGearModeLoaderText = (isStreaming: boolean) => {
  if (isStreaming) {
    return (
      <div>
        <h3>
          <FormattedMessage defaultMessage="Initializing preview" />
        </h3>
        <h4>
          <FormattedMessage defaultMessage="Streaming is starting..." />
        </h4>
      </div>
    )
  }

  return (
    <div>
      <h3>
        <FormattedMessage defaultMessage="Running Gear Mode" />
      </h3>
      <h4>
        <FormattedMessage defaultMessage="Waiting for you to start streaming..." />
      </h4>
    </div>
  )
}

interface GearModeProps {
  showGearModePlayer: boolean
  isStreaming: boolean
  liveData: any
}

const GearMode = ({
  showGearModePlayer,
  isStreaming,
  liveData,
}: GearModeProps) => {
  if (!showGearModePlayer) {
    return (
      <>
        <BigLoaderComponent
          className="gear-mode-loader"
          loadingText={getGearModeLoaderText(isStreaming)}
        />
        <StreamingInfoPanelComponent
          quality="1080p"
          bitrate="3000 kbit/s"
          server={liveData.publish_server}
          streamName={liveData.publish_stream__mbr}
          fmleURL={liveData.fmle_url__mbr}
        />
      </>
    )
  }

  return (
    <>
      <div className="gear-player-wrapper">
        <VideoPlayerComponent
          object={liveData}
          objectType="live"
          options={{
            mutedAutoPlay: 1,
            stream_preview_p: 1,
            corePeopleDisabled: 1,
            showStreamingPreviewLabel: 0,
          }}
        />
      </div>
      <RibbonComponent
        className="gear-mode-hint"
        color="#fac546"
        backgroundColor="rgba(0, 0, 0, 0.62)"
        styles={{ color: '#FFF' }}
        iconNode={
          <IconComponent name="gear-mode" size={[16, 16]} color="FFF" />
        }
        message={
          <div>
            <h4>
              <FormattedMessage defaultMessage="Running in Gear Mode" />
            </h4>
            <FormattedMessage defaultMessage="This stream is running from your production gear. You are watching the stream your audience sees." />
          </div>
        }
      />
    </>
  )
}

export default GearMode
